import React, { FC } from 'react';

export const FilledCheckIcon: FC<React.PropsWithChildren<{ className?: string }>> = ({
  className = ''
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#059450" />
      <path
        d="M9.86339 14.5833L7.08339 11.8033L6.13672 12.7433L9.86339 16.47L17.8634 8.47L16.9234 7.53L9.86339 14.5833Z"
        fill="white"
      />
    </svg>
  );
};
